import type { PropsWithChildren } from 'react'

export enum AuthStatus {
  UNAUTHENTICATED = 'UNAUTHENTICATED',
  AUTHENTICATED = 'AUTHENTICATED',
  AUTHENTICATING = 'AUTHENTICATING',
  RENEWING = 'RENEWING'
}

export type AuthContextProps = {
  authStatus?: AuthStatus
  setAuthStatus?: React.Dispatch<React.SetStateAction<AuthStatus>>
}

export type AuthProviderProps = PropsWithChildren<AuthContextProps>
